import React, {useContext, useEffect, useRef, useState} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import {getStreets} from "../../../../../utils/location-utils.js";
import OptionsUtils from "../../../../../utils/options-utils.js";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import {CorporationContext} from "../../context/corporation-context.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import {FaTimes} from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CitizenSos = () => {
    const {state, setState, setChanges, entity, handleInputMask} = useContext(CorporationContext)
    const [sosScr, setSosSrc] = useState(`${API_URL}/corporation/entity/sos-image`);
    const [backGroundMaria, setBackGroundMaria] = useState("");
    const [backGroundCitizen, setBackGroundCitizen] = useState(`url(${API_URL}/corporation/entity/image)`);
    const [open, setOpen] = useState(false);
    const [backgroundUrl, setBackgroundUrl] = useState("");
    const sosRef = useRef();
    const mariaRef = useRef();

    const triggerSos = () => sosRef.current?.click();
    const triggerMaria = () => mariaRef.current?.click();
    const onChange = ({target: {value, id}}) => handleInputs(value, id)

    const onChangeSelection = (id, value) => handleInputs(value, id);

    const handleCheckBox = (element) => {
        let {id, checked} = element.target;
        handleInputs(checked, id);
    }
    const handleInputs = (value, id) => {
        setState(prev => ({...prev, [id]: value}));
        setChanges(prev => (prev.includes("citizen_sos") ? prev : [...prev, "citizen_sos"]))
    }

    const attachImage = ({target: {files, id}}) => {
        const file = files[0];
        const reader = new FileReader();

        if (file.size >= 2000000) {
            projectUtils.swalErrorMessage('', 'Tamanho máximo de arquivo excedido. Limite: 2MB.', 'Ok');
            return;
        }

        reader.onload = function (e) {
            id === "logoSos" ? setSosSrc(e.target.result) : setBackGroundMaria(`url(${e.target.result})`);
        }

        reader.readAsDataURL(file);
        setState(prev => ({...prev, [id]: file}))
        setChanges("citizen_sos");
    }

    const removeFile = (id) => {
        setState(prev => ({...prev, [id]: null}));
        id === "logoSos" ? setSosSrc(null) : setBackGroundMaria(null);
        setChanges("citizen_sos");
    }

    const openModal = (target) => {
        if (target === "citizen") sosScr ? setBackgroundUrl(`url(${sosScr})`) : setBackgroundUrl(`url(${API_URL}/corporation/entity/sos-image)`)
        if (target === "penha") setBackgroundUrl(backGroundMaria)
        setOpen(true);
    }

    useEffect(() => {
        if (entity?.maria_da_penha_image) {
            setBackGroundMaria(`url(${API_KEEPER}/ged/attach/${entity.maria_da_penha_image})`)
        } else {
            setBackGroundMaria(`url(${API_URL}/corporation/entity/sos-image)`)
        }
    }, [entity]);

    useEffect(() => {
        setBackGroundCitizen(`url(${sosScr})`)
    }, [sosScr]);

    useEffect(() => {
        if (state.same_info) {
            setState(prev => ({
                ...prev,
                sos_address: state.address,
                sos_number: state.number,
                sos_phone: state.phone,
                sos_email: state.institutional_email
            }));
        } else if (state.address === state.sos_address && state.number === state.sos_number && state.phone === state.sos_phone && state.sos_email === state.institutional_email) {
            setState(prev => ({
                ...prev,
                sos_address: "",
                sos_number: "",
                sos_phone: "",
                sos_email: ""
            }));
        }

    }, [state.same_info]);

    return (
        <>
            <Card>
                <Card.Header className={"!justify-between"}>
                    <Card.Title>
                        SOS Cidadão
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-8">
                            <div className="grid grid-cols-12 gap-4">
                                <div className="col-span-6">
                                    <InputForm
                                        id="sos_display_name"
                                        value={state.sos_display_name}
                                        label="Nome de exibição"
                                        onChange={onChange}
                                    />
                                </div>

                                <div className="col-span-6">
                                    <InputForm
                                        id="alternative_phone"
                                        name="alternative_phone"
                                        value={state.alternative_phone}
                                        onChange={onChange}
                                        onBlur={handleInputMask}
                                        label="Telefone"
                                        mask={[
                                            { mask: '(00) 0000-0000' },
                                            { mask: '(00) 00000-0000' }
                                        ]}
                                    />
                                </div>

                                <div className="col-span-6">
                                    <InputForm
                                        id="sos_email"
                                        value={state.sos_email}
                                        label="E-mail"
                                        onChange={onChange}
                                    />
                                </div>
                            </div>

                            <div className="mt-3">
                                <InputCheckbox
                                    id="same_info"
                                    checked={state.same_info}
                                    label="Utilizar mesmo endereço, email e telefone da Corporação"
                                    onChange={handleCheckBox}
                                />
                            </div>

                            <div className="grid grid-cols-12 gap-4 mt-3 mb-3">
                                <div className="col-span-6">
                                    <SelectComponent
                                        isDisabled={state.same_info}
                                        loadOptions={getStreets}
                                        value={OptionsUtils.getValue(state.sos_address)}
                                        isAsync={true}
                                        label="Logradouro"
                                        onChange={(selected) => onChangeSelection("sos_address", selected?.value)}
                                        cacheOptions
                                        defaultOptions={[]}
                                    />
                                </div>

                                <div className="col-span-3">
                                    <InputForm
                                        id="sos_number"
                                        disabled={state.same_info}
                                        value={state.sos_number}
                                        label="Número"
                                        onChange={onChange}
                                    />
                                </div>

                                <div className="col-span-3">
                                    <InputForm
                                        id="sos_phone"
                                        name="sos_phone"
                                        value={state.sos_phone}
                                        onChange={onChange}
                                        onBlur={handleInputMask}
                                        label="Telefone"
                                        disabled={state.same_info}
                                        mask={[
                                            { mask: '(00) 0000-0000' },
                                            { mask: '(00) 00000-0000' }
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-span-4">
                            <div>
                                <div className="image-effective">
                                    <label>Logo para SOS Cidadão</label>
                                    <div
                                        className="h-[158px] border border-[#e0e0e0] rounded p-[5px]  cursor-pointer bg-center bg-contain bg-no-repeat"
                                        onClick={() => openModal("citizen")}
                                        style={{ backgroundImage: backGroundCitizen }}
                                    >
                                        <Button target={"danger"} className={"!w-[25px] !h-[25px] !p-0 absolute right-[10px]"}
                                                onClick={() => removeFile("logoSos")} title="Remover imagem">
                                            <FaTimes />
                                        </Button>
                                    </div>

                                    <input type="hidden" name="imageId" value={state.imageId ?? ""}/>
                                    <input
                                        type="file"
                                        accept="image/png, image/jpeg"
                                        id="logoSos"
                                        className="hidden"
                                        name="image"
                                        onChange={attachImage}
                                        ref={sosRef}
                                    />

                                    <Button className={"w-full"} onClick={triggerSos}>
                                        <span>Selecionar foto</span>
                                    </Button>

                                    <small>* Tamanho máximo 2MB</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Modal open={open} setOpen={setOpen} title={"Logo"}>
                <Modal.Body>
                    <div className={"bg-center bg-no-repeat bg-contain overflow-hidden h-[500px]"}
                         style={{backgroundImage: `${backgroundUrl}`}}
                    ></div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CitizenSos;